import React, { Fragment } from 'react';

import AddEventBtn from 'components/AddEventBtn';

const EmptyPage = ({ pageTitle = 'Untitled' }) => (
  <Fragment>
    <div>
      <div className="text-right pb-8">
        <AddEventBtn to="/dashboard/evento-nuevo" text="Agregar Evento" />
      </div>
      <div className="flex flex-wrap">
        <h1 className="leading-tight text-2xl">{pageTitle} &middot; WIP</h1>
      </div>
    </div>
  </Fragment>
);

export default EmptyPage;
